var _g, _g2, _g3, _g4, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgCalendarEmptyVisitors(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 155,
    viewBox: "0 0 206 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.178 28.016a.182.182 0 01.23.118c.633 1.993 1.27 3.977 1.905 5.96.637 1.984 1.273 3.968 1.907 5.96l.23.708c.94 2.876 1.875 5.742 3.294 8.432 1.24 2.347 2.795 4.503 4.35 6.658a155.45 155.45 0 011.703 2.389l-.15.104.15-.104c1.61 2.316 3.103 4.73 4.59 7.136.82 1.326 1.638 2.65 2.474 3.954 2.358 3.677 4.865 7.21 7.972 10.255 4.066 3.985 8.918 6.895 14.041 9.45 2.558 1.276 5.18 2.461 7.804 3.648l.015.007c2.628 1.188 5.26 2.378 7.824 3.658 1.885.95 3.874 2.123 5.425 3.594 1.551 1.472 2.677 3.254 2.804 5.417a.182.182 0 01-.364.022c-.12-2.041-1.18-3.741-2.691-5.174-1.512-1.435-3.464-2.589-5.337-3.533l.082-.163-.082.163c-2.557-1.277-5.182-2.463-7.811-3.652l-.019-.009c-2.622-1.185-5.25-2.373-7.812-3.651-5.138-2.563-10.029-5.493-14.134-9.517l.128-.13-.128.13c-3.136-3.073-5.661-6.634-8.024-10.319a284.049 284.049 0 01-2.485-3.972c-1.484-2.4-2.966-4.797-4.572-7.106-.548-.79-1.115-1.576-1.684-2.365-1.56-2.162-3.14-4.349-4.391-6.72-1.434-2.718-2.38-5.614-3.316-8.484l-.233-.713v-.001c-.634-1.993-1.27-3.976-1.907-5.96-.636-1.984-1.272-3.968-1.906-5.961a.182.182 0 01.118-.23z",
    fill: "#719143"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.266 86.538c-5.007-3.147-11.522-4.58-16.95-2.217-3.896 1.7-6.746 5.055-9.457 8.292.127-.233.247-.43.41-.655 7.147 2.771 15.634 2.257 21.981-2.029 1.34-.968 2.677-2.423 4.016-3.391zM56.217 72.082c-4.628 4.45-10.728 7.969-17.12 7.312-4.671-.494-8.854-3.156-13.529-3.8 3.832-4.068 9.246-6.696 14.8-7.46 5.553-.766 11.321.498 16.076 3.44.403.202-.394.92-.227.508zM44.334 54.193c-3.327 1.828-6.812 3.695-10.628 3.88-8.064.46-14.731-6.424-22.681-7.956 5.96.41 11.1-2.99 17.04-3.48 6.585-.533 12.205 2.38 16.27 7.556zM38.615 41.281c-5.117.154-10.319-1.468-14.405-4.557-3.203-2.367-5.735-5.554-8.938-7.92 4.917.399 9.708.695 14.353 2.303 4.68 1.616 6.73 5.778 8.99 10.174zM32.39 3.443c-2.808 4-3.892 9.137-2.95 13.908.941 4.771 3.96 9.114 8.123 11.698.926-3.94 1.638-7.926.496-11.809-.758-2.6-2.261-4.882-3.511-7.294s-2.431-3.8-2.158-6.503zM72.836 85.21c-2.423-2.676-2.781-6.718-1.738-10.182 1.043-3.464 3.203-6.414 5.446-9.234 2.243-2.82 4.593-5.616 6.046-8.912.016 2.582-.142 4.937-.198 7.503-.132 5.389-.795 11.143-4.327 15.204-.912 1.065-1.97 1.947-3.065 2.822-.971.827-1.192 1.973-2.164 2.8zM58.65 70.576c-1.258-2.377-.9-5.285-.173-7.85 2.211-7.647 7.574-14.359 14.596-18.156-.13 4.717-.44 9.243-2 13.674-1.525 4.44-4.48 8.593-8.749 10.62-1.207.55-2.447 1.241-3.674 1.712zM50.075 55.413c-1.21-1.095-1.113-3.016-.76-4.58 1.88-8.171 8.195-14.631 14.96-19.607-1.094 2.369-1.138 4.713-1.53 7.278a39.327 39.327 0 01-2.583 9.133c-.745 1.812-1.668 3.584-3.06 4.952-2.042 1.93-4.375 2.002-7.027 2.824zM43.3 42.712c-.031-5.164 1.812-10.353 5.134-14.312 2.298-2.733 5.21-4.878 7.446-7.662-.195 1.525-.068 2.45-.262 3.976-.596 4.462-1.29 9.2-4.318 12.516-2.544 2.827-5.682 2.492-8 5.482zM88.144 90.57c-.653.077-1.12-.664-1.312-1.305-.95-3.241.116-6.812 2.015-9.597 1.9-2.786 4.59-4.944 7.258-6.995 2.668-2.052 5.414-4.122 7.475-6.796-.521 8.44-5.307 16.403-12.281 21.145-1.446.944-3.327 1.828-3.155 3.548zM60.585 109.539c1.117-3.298 3.135-7.439 6.816-11.167 2.749-2.743 4.796-4.86 8.04-5.324 2.317-.337 3.73.356 8.875.246 1.617-.046 2.915-.165 3.788-.23-.828 2.019-4.85 10.902-14.751 14.871-5.293 2.095-10.116 1.941-12.768 1.604z",
    fill: "#BCC7C8"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.64,
    clipPath: "url(#imgCalendarEmptyVisitors_svg__clip0_4870_64411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.072 128.494c1.235 1.765 2.931 5.025 1.563 9.142-.981 2.997-3.628 6.516-5.099 6.486-1.601-.036-1.795-4.248-1.017-7.484.827-3.494 2.921-6.321 4.553-8.144z",
    fill: "#CED9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.398 51.641c55.774 22.846 64.106 47.609 66.388 59.763.29 1.545.82 6.648 1.137 12.968.11 2.046.167 3.076.152 4.138-.02 3.544-.641 8.799-3.536 15.628",
    stroke: "#9EABAD",
    strokeWidth: 0.339,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.763 121.565c-1.721 1.262-5.42 3.657-6.593 3.202-1.169-.439.571-3.491 1.885-5.233 1.473-1.972 4.834-5.521 12.687-8.849-1.806 5.746-5.607 9.154-7.979 10.88z",
    fill: "#CED9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.717 110.691c-4.848 4.697-9.72 9.4-14.568 14.097l14.568-14.097z",
    fill: "#CED9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.717 110.691c-4.848 4.697-9.72 9.4-14.568 14.097",
    stroke: "#9EABAD",
    strokeWidth: 0.339,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.497 112.922c-2.289 1.378-7.213 3.941-8.639 3.257-1.422-.669 1.058-4.253 2.883-6.264 2.05-2.289 6.623-6.318 16.878-9.591-2.826 6.914-7.961 10.711-11.122 12.598zM167.594 100.329l-19.736 15.85 19.736-15.85z",
    fill: "#CED9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.594 100.329l-19.736 15.85",
    stroke: "#9EABAD",
    strokeWidth: 0.339,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.391 103.926c-2.288 1.378-7.213 3.941-8.638 3.257-1.422-.669 1.057-4.253 2.882-6.264 2.051-2.289 6.624-6.318 16.879-9.591-2.851 6.919-7.962 10.711-11.123 12.598zM162.489 91.333l-19.736 15.85 19.736-15.85z",
    fill: "#CED9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.489 91.333l-19.736 15.85",
    stroke: "#9EABAD",
    strokeWidth: 0.339,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.621 134.708c-1.08-.374.969-4.052 3.679-6.89 2.541-2.654 5.623-4.426 7.794-5.499-.391 1.983-1.511 5.305-5.18 8.604-1.996 1.798-5.351 4.122-6.293 3.785z",
    fill: "#CED9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.069 122.324c-3.753 4.143-7.531 8.291-11.284 12.433l11.284-12.433z",
    fill: "#CED9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.069 122.324c-3.753 4.143-7.531 8.291-11.284 12.433",
    stroke: "#9EABAD",
    strokeWidth: 0.339,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.317 118.916c1.892.705 5.912 1.884 6.985 1.102 1.049-.777-1.172-3.218-2.749-4.516-1.767-1.475-5.657-3.904-13.869-4.722 2.751 5.029 7.021 7.182 9.633 8.136z",
    fill: "#CED9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.684 110.78c5.54 3.085 11.078 6.153 16.618 9.238",
    stroke: "#9EABAD",
    strokeWidth: 0.339,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.732 109.138c2.469.636 7.683 1.62 8.973.512 1.268-1.086-1.76-3.825-3.869-5.213-2.383-1.596-7.55-4.112-18.069-4.143 3.924 5.863 9.576 7.982 12.965 8.844z",
    fill: "#CED9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.742 100.299c7.321 3.117 14.642 6.234 21.966 9.367",
    stroke: "#9EABAD",
    strokeWidth: 0.339,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.719 96.525c2.781.026 8.514-.22 9.287-1.47.747-1.246-3.6-3.02-6.41-3.817-3.168-.907-9.545-2.05-20.165.19 6.759 4.39 13.45 5.055 17.288 5.097z",
    fill: "#CED9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.431 91.427c8.859 1.214 17.715 2.413 26.575 3.627",
    stroke: "#9EABAD",
    strokeWidth: 0.339,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.949 96.208c-2.465 1.646-7.799 4.722-9.505 4.046-1.706-.676.743-4.784 2.605-7.117 2.081-2.642 6.876-7.346 18.188-11.48-2.462 7.816-7.896 12.285-11.288 14.551z",
    fill: "#CED9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.234 81.641l-20.793 18.597",
    stroke: "#9EABAD",
    strokeWidth: 0.339,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.425 86.608c3.166-.103 9.659-.654 10.421-2.083.736-1.425-4.433-3.196-7.697-3.95-3.698-.865-11.09-1.817-22.942 1.187 8.154 4.552 15.85 4.978 20.218 4.846z",
    fill: "#CED9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.179 81.751l30.639 2.763",
    stroke: "#9EABAD",
    strokeWidth: 0.339,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.886 88.987c-2.498 1.984-7.992 5.788-10.047 5.166-2.051-.606-.003-5.293 1.682-7.987 1.894-3.05 6.471-8.57 18.574-13.99-1.417 8.776-6.781 14.092-10.209 16.811z",
    fill: "#CED9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.098 72.192l-20.259 21.961",
    stroke: "#9EABAD",
    strokeWidth: 0.339,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.859 76.013c3.578-.352 10.854-1.476 11.418-3.114.571-1.605-5.603-3.138-9.443-3.692-4.345-.632-12.897-1.1-25.809 3.131 10.111 4.316 18.898 4.172 23.834 3.675z",
    fill: "#CED9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.05 72.333c11.735.196 23.495.386 35.227.566",
    stroke: "#9EABAD",
    strokeWidth: 0.339,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.468 81.61c-2.764 2.32-8.85 6.741-11.242 6.106-2.368-.64-.277-5.998 1.51-9.076 2.032-3.51 6.977-9.865 20.572-16.286-1.156 9.93-7.043 16.08-10.84 19.257z",
    fill: "#CED9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.305 62.338c-7.369 8.456-14.714 16.906-22.079 25.378",
    stroke: "#9EABAD",
    strokeWidth: 0.339,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.634 64.118c4.066-.733 12.229-2.668 12.566-4.54.318-1.835-7.152-2.92-11.703-3.18-5.173-.282-15.161.025-29.171 5.92 12.581 3.827 22.71 2.83 28.308 1.8z",
    fill: "#CED9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.305 62.339c13.615-.917 27.258-1.823 40.873-2.74",
    stroke: "#9EABAD",
    strokeWidth: 0.339,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.193 130.689c.964-.693-1.646-3.65-4.789-5.57-2.939-1.798-6.238-2.595-8.522-2.955.729 1.803 2.402 4.703 6.53 6.786 2.257 1.11 5.928 2.344 6.781 1.739z",
    fill: "#CED9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.904 122.143c4.367 2.878 8.759 5.751 13.126 8.629",
    stroke: "#9EABAD",
    strokeWidth: 0.339,
    strokeMiterlimit: 10
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#imgCalendarEmptyVisitors_svg__filter0_i_4870_64411)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7F9F9",
    d: "M58.751 56.282h97.461v64.025H58.751z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#imgCalendarEmptyVisitors_svg__filter1_i_4870_64411)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.203 33.09H56.758v22.054h101.445V33.091zm-14.225 11.027a7.076 7.076 0 11-14.152 0 7.076 7.076 0 0114.152 0zm-58.077.023a7.075 7.075 0 11-14.15 0 7.075 7.075 0 0114.15 0z",
    fill: "#41CBCE"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.059 30.973h20.752V27.2c0-1.132.754-1.886 1.886-1.886s1.887.754 1.887 1.886v3.773h54.709V27.2c0-1.132.755-1.886 1.887-1.886 1.132 0 1.886.754 1.886 1.886v3.773h18.866c1.132 0 1.886.755 1.886 1.887v22.638c0 1.132-.754 1.887-1.886 1.887v34.9c0 1.132-.755 1.887-1.887 1.887-1.132 0-1.886-.755-1.886-1.887v-34.9H59.832v62.255h94.327V107c0-1.132.754-1.886 1.886-1.886s1.887.754 1.887 1.886v12.64a3.784 3.784 0 01-3.773 3.773H59.832a3.784 3.784 0 01-3.773-3.773V57.385c-1.132 0-1.886-.755-1.886-1.887V32.86c0-1.132.754-1.887 1.886-1.887zm99.986 22.639V34.745h-16.979v2.075c3.207.755 5.66 3.773 5.66 7.358 0 4.15-3.396 7.546-7.546 7.546-4.151 0-7.546-3.396-7.546-7.546 0-3.585 2.452-6.414 5.659-7.358v-2.075h-54.71v2.075c3.208.755 5.66 3.773 5.66 7.358 0 4.15-3.395 7.546-7.546 7.546-4.15 0-7.546-3.396-7.546-7.546 0-3.585 2.453-6.414 5.66-7.358v-2.075H57.945v18.865h98.1zm-18.865-9.433c-1.132 0-1.887-.755-1.887-1.887v-1.32c-1.132.566-1.886 1.886-1.886 3.207a3.784 3.784 0 003.773 3.773 3.784 3.784 0 003.773-3.773c0-1.32-.755-2.641-1.887-3.207v1.32c0 1.132-.754 1.887-1.886 1.887zm-58.483 0c-1.132 0-1.886-.755-1.886-1.887v-1.32c-1.132.566-1.887 1.886-1.887 3.207a3.784 3.784 0 003.773 3.773 3.784 3.784 0 003.773-3.773c0-1.32-.754-2.641-1.886-3.207v1.32c0 1.132-.755 1.887-1.887 1.887z",
    fill: "#1D8487"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M156.045 101.718c-1.132 0-1.886-.943-1.886-1.886 0-.944.754-1.887 1.886-1.887s1.887.755 1.887 1.887c0 .943-.755 1.886-1.887 1.886z",
    fill: "#1D8487"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "imgCalendarEmptyVisitors_svg__filter0_i_4870_64411",
    x: 58.751,
    y: 56.282,
    width: 97.461,
    height: 64.025,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.231373 0 0 0 0 0.254902 0 0 0 0 0.258824 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4870_64411"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "imgCalendarEmptyVisitors_svg__filter1_i_4870_64411",
    x: 56.758,
    y: 33.091,
    width: 101.445,
    height: 22.053,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.34 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4870_64411"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "imgCalendarEmptyVisitors_svg__clip0_4870_64411"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "scale(1 -1) rotate(11.565 821.916 505.969)",
    d: "M0 0h81.514v103.64H0z"
  })))));
}
export default SvgImgCalendarEmptyVisitors;